/* eslint-disable */
import React from "react";
import { useHistory } from "react-router-dom";
import { Upload, Users, Wallet, ShoppingCart, FileText, KeyRound, ArrowRight } from "lucide-react";
import RenderITOfficerPage from "./RenderITOfficerPage";

const cards = [
  {
    label: "Upload Loans",
    desc: "Upload loan deduction files",
    icon: <FileText size={22} />,
    color: "blue",
    path: "/it/upload-loans",
  },
  {
    label: "Upload Mart",
    desc: "Upload mart deduction files",
    icon: <ShoppingCart size={22} />,
    color: "emerald",
    path: "/it/upload-mart",
  },
  {
    label: "Upload Funds",
    desc: "Upload fund contribution files",
    icon: <Wallet size={22} />,
    color: "purple",
    path: "/it/upload-funds",
  },
  {
    label: "Upload Staff Loans",
    desc: "Upload UPNMG staff loan deductions",
    icon: <FileText size={22} />,
    color: "blue",
    path: "/it/upload-staff-loans",
  },
  {
    label: "Upload Staff Mart",
    desc: "Upload UPNMG staff mart deductions",
    icon: <ShoppingCart size={22} />,
    color: "emerald",
    path: "/it/upload-staff-mart",
  },
  {
    label: "Upload Staff Funds",
    desc: "Upload UPNMG staff fund contributions",
    icon: <Wallet size={22} />,
    color: "purple",
    path: "/it/upload-staff-funds",
  },
  {
    label: "Upload Members",
    desc: "Bulk upload member accounts",
    icon: <Upload size={22} />,
    color: "orange",
    path: "/it/upload-members",
  },
  {
    label: "Reset Member Account",
    desc: "Reset a member's password",
    icon: <KeyRound size={22} />,
    color: "rose",
    path: "/it/reset-member",
  },
];

const colorMap = {
  blue: {
    bg: "bg-blue-50 dark:bg-blue-900/20",
    icon: "bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-400",
    border: "border-blue-100 dark:border-blue-800",
    arrow: "text-blue-500",
  },
  emerald: {
    bg: "bg-emerald-50 dark:bg-emerald-900/20",
    icon: "bg-emerald-100 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400",
    border: "border-emerald-100 dark:border-emerald-800",
    arrow: "text-emerald-500",
  },
  purple: {
    bg: "bg-purple-50 dark:bg-purple-900/20",
    icon: "bg-purple-100 dark:bg-purple-900/40 text-purple-600 dark:text-purple-400",
    border: "border-purple-100 dark:border-purple-800",
    arrow: "text-purple-500",
  },
  orange: {
    bg: "bg-orange-50 dark:bg-orange-900/20",
    icon: "bg-orange-100 dark:bg-orange-900/40 text-orange-600 dark:text-orange-400",
    border: "border-orange-100 dark:border-orange-800",
    arrow: "text-orange-500",
  },
  rose: {
    bg: "bg-rose-50 dark:bg-rose-900/20",
    icon: "bg-rose-100 dark:bg-rose-900/40 text-rose-600 dark:text-rose-400",
    border: "border-rose-100 dark:border-rose-800",
    arrow: "text-rose-500",
  },
};

function ITOfficerDashboard() {
  const history = useHistory();
  return (
    <RenderITOfficerPage title="IT Officer Dashboard">
      <p className="text-sm text-slate-500 dark:text-slate-400 -mt-4 mb-6">
        Manage uploads and member accounts from this panel.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((card) => {
          const c = colorMap[card.color];
          return (
            <button
              key={card.path}
              onClick={() => history.push(card.path)}
              className={`text-left p-5 rounded-2xl border ${c.border} ${c.bg} hover:shadow-md transition-all group`}
            >
              <div className="flex items-start justify-between mb-4">
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${c.icon}`}>
                  {card.icon}
                </div>
                <ArrowRight size={16} className={`${c.arrow} opacity-0 group-hover:opacity-100 transition-opacity`} />
              </div>
              <p className="text-sm font-bold text-slate-800 dark:text-slate-100">{card.label}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{card.desc}</p>
            </button>
          );
        })}
      </div>
    </RenderITOfficerPage>
  );
}

export default ITOfficerDashboard;
